// AURA — IT/EN translations
export const translations = {
  it: {
    nav: {
      features: "Funzionalità",
      dashboard: "Dashboard",
      pricing: "Prezzi",
      faq: "FAQ",
      cta: "Prenota una demo",
    },
    hero: {
      eyebrow: "CRM per estetiste · Edizione 2026",
      title_a: "L'aura del tuo",
      title_b: "salone,",
      title_c: "amplificata.",
      subtitle:
        "AURA è la piattaforma intelligente che unisce agenda, clienti, magazzino e skin analysis AI in un'unica esperienza pensata per chi crea bellezza.",
      cta_primary: "Inizia la prova gratuita",
      cta_secondary: "Guarda la dashboard",
      // Caratteristiche del prodotto, non risultati vantati: sono verificabili
      // aprendo il software. Non reintrodurre qui numeri senza prove.
      highlights: [
        "Nessuna installazione",
        "Prova di 30 giorni",
        "Dati conservati in Europa",
      ],
    },
    features: {
      eyebrow: "Tutto ciò che serve",
      title: "Un solo strumento.",
      title_accent: "Mille gesti di cura.",
      subtitle:
        "Dalla prenotazione al follow-up, ogni dettaglio è progettato per farti risparmiare tempo e accendere l'esperienza cliente.",
      items: {
        agenda: {
          title: "Agenda smart",
          desc: "Calendario drag & drop, slot intelligenti e promemoria automatici via WhatsApp.",
        },
        clienti: {
          title: "Schede clienti",
          desc: "Storia trattamenti, preferenze e note personali in un'unica vista elegante.",
        },
        trattamenti: {
          title: "Catalogo trattamenti",
          desc: "Pacchetti, abbonamenti e prezzi personalizzati per ogni operatrice.",
        },
        magazzino: {
          title: "Magazzino vivo",
          desc: "Scorte in tempo reale, alert automatici e ordini ai fornitori in un click.",
        },
        fidelity: {
          title: "Fidelity & Wallet",
          desc: "Punti, premi e gift card digitali per fidelizzare la tua community.",
        },
        skin: {
          title: "Skin Analysis AI",
          desc: "Analisi visiva della pelle con suggerimento trattamenti basato su intelligenza artificiale.",
        },
        mobile: {
          title: "App mobile",
          desc: "La tua estetica sempre in tasca. Per te e per le tue clienti.",
        },
        preventivi: {
          title: "Preventivi & Vendita",
          desc: "Crea preventivi eleganti e gestisci la vendita banco senza fatica.",
        },
        bolle: {
          title: "Bolle in automatico",
          desc: "Scatta la foto della bolla: l'AI legge prodotti, lotti e quantità e aggiorna il magazzino in tempo reale.",
          badge: "AI",
          tag1: "OCR intelligente",
          tag2: "0 errori manuali",
          tag3: "Sincronizza fornitori",
        },
        nails: {
          title: "Rendering unghie AI",
          desc: "Mostra in anteprima alla cliente il colore di smalto direttamente sulle sue mani, prima del trattamento.",
          badge: "AI",
        },
        marketing: {
          title: "Marketing & AI",
          desc: "Campagne automatiche di compleanno, richiami clienti e newsletter con testi generati dall'Intelligenza Artificiale.",
          badge: "AI",
        },
      },
    },
    dashboard: {
      eyebrow: "Dashboard preview",
      title: "Una vista. Tutto sotto controllo.",
      subtitle:
        "Apri AURA e ricevi subito il briefing del mattino: appuntamenti, incassi attesi, clienti da richiamare e scorte basse. Niente caos, solo chiarezza.",
      bullet_1: "Briefing AI personalizzato ogni mattina",
      bullet_2: "KPI in tempo reale con grafici eleganti",
      bullet_3: "Operatori top, obiettivi e trend mensili",
    },
    pricing: {
      eyebrow: "I nostri piani",
      title: "Il piano giusto",
      title_accent: "per ogni atelier.",
      subtitle: "Tre livelli, su misura per il momento del tuo salone. Richiedi un preventivo personalizzato senza impegno.",
      most_popular: "Più scelto",
      cta: "Richiedi un preventivo",
      custom_price: "Su misura",
      plans: {
        essence: {
          name: "Essence",
          desc: "Per chi inizia con stile.",
          features: [
            "Agenda smart illimitata",
            "Fino a 500 schede cliente",
            "Promemoria WhatsApp",
            "App mobile titolare",
            "Supporto via email",
          ],
        },
        atelier: {
          name: "Atelier",
          desc: "Il preferito dei saloni in crescita.",
          features: [
            "Tutto Essence +",
            "Schede cliente illimitate",
            "Magazzino & fornitori",
            "Fidelity, gift card, preventivi",
            "Multi-operatore (fino a 5)",
            "Supporto prioritario",
          ],
        },
        maison: {
          name: "Maison",
          desc: "Per saloni boutique e catene.",
          features: [
            "Tutto Atelier +",
            "Skin Analysis AI illimitata",
            "Operatori illimitati & multi-sede",
            "API & integrazioni custom",
            "Onboarding dedicato",
            "Account manager personale",
          ],
        },
      },
    },
    faq: {
      eyebrow: "Domande frequenti",
      title: "Hai qualche dubbio?",
      title_accent: "Lo capiamo, è importante.",
      items: [
        {
          q: "Devo installare qualcosa?",
          a: "No. AURA è completamente in cloud. Apri il browser o l'app mobile e sei subito operativa. Nessuna installazione, nessun aggiornamento da gestire.",
        },
        {
          q: "Posso importare i dati dal mio vecchio gestionale?",
          a: "Sì. Il nostro team si occupa gratuitamente della migrazione completa di schede cliente, agenda, trattamenti e storico. In media servono 48 ore.",
        },
        {
          q: "Le mie clienti possono prenotare online?",
          a: "Certo. Ogni piano include una pagina di prenotazione personalizzata con il tuo logo e i tuoi colori, integrata con Instagram e Google.",
        },
        {
          q: "Come funziona Skin Analysis AI?",
          a: "Scatti una foto del viso della cliente, l'AI analizza tono, idratazione, imperfezioni e suggerisce i trattamenti più adatti dal tuo catalogo.",
        },
        {
          q: "Posso cancellare quando voglio?",
          a: "Sempre. Nessun vincolo, nessuna penale. Disdici con un click dal pannello di amministrazione.",
        },
      ],
    },
    final_cta: {
      eyebrow: "Inizia oggi",
      title: "Accendi l'aura",
      title_accent: "del tuo salone.",
      subtitle: "30 giorni di prova. Setup gratuito. Nessuna carta richiesta.",
      cta_primary: "Prenota una demo",
      cta_secondary: "Parla con un consulente",
    },
    footer: {
      tagline: "Il CRM intelligente per estetiste contemporanee.",
      product: "Prodotto",
      company: "Azienda",
      legal: "Legale",
      links: {
        features: "Funzionalità",
        pricing: "Prezzi",
        dashboard: "Dashboard",
        contact: "Contatti",
        ai: "Uso dell'IA",
        legal_notice: "Note legali",
        privacy: "Privacy Policy",
        terms: "Termini di servizio",
        cookies: "Cookie Policy",
        cookie_prefs: "Preferenze cookie",
      },
      copyright: "© 2026 AURA. Tutti i diritti riservati.",
    },
    demo_form: {
      title: "Prenota una demo gratuita",
      subtitle: "Ti richiamiamo entro 24 ore per mostrarti AURA dal vivo.",
      name: "Nome e cognome",
      name_ph: "Il tuo nome",
      email: "Email",
      email_ph: "tu@salone.it",
      phone: "Telefono",
      phone_ph: "+39 ...",
      salon: "Nome del salone",
      salon_ph: "Es. Bellezza Atelier",
      plan: "Piano d'interesse",
      plan_any: "Non so ancora",
      message: "Raccontaci di te (opzionale)",
      message_ph: "Quanti operatori, quale gestionale usi oggi...",
      consent: "Ho letto e compreso l'",
      privacy_link: "informativa sulla privacy",
      privacy_note:
        "Usiamo i tuoi dati solo per ricontattarti e mostrarti AURA. Nessuna comunicazione commerciale senza un tuo consenso separato, nessuna cessione a terzi.",
      submit: "Prenota la demo",
      submitting: "Invio in corso…",
      success_title: "Grazie! ✨",
      success_msg: "Abbiamo ricevuto la tua richiesta. Ti contatteremo a breve.",
      success_close: "Chiudi",
      error: "Qualcosa è andato storto. Riprova tra poco.",
    },
    cookies: {
      title: "Solo cookie tecnici",
      // Testo mostrato quando NON ci sono categorie non necessarie: dice la
      // verità sullo stato attuale del sito, senza promettere scelte che non
      // esistono.
      body_technical:
        "Questo sito usa solo cookie tecnici, necessari a farlo funzionare e a tenerti collegata alla tua area riservata. Nessuna profilazione, nessuna statistica, nessun tracciamento di terze parti.",
      body_granular:
        "Usiamo cookie tecnici, sempre attivi. Gli altri vengono installati solo se lo autorizzi: puoi accettare, rifiutare o scegliere categoria per categoria.",
      ack: "Ho capito",
      accept: "Accetta tutti",
      reject: "Solo essenziali",
      customize: "Personalizza",
      save: "Salva le preferenze",
      more: "Cookie Policy",
      close_aria: "Chiudi l'avviso senza accettare",
      always_on: "Sempre attivi",
      cat_necessary_title: "Cookie tecnici",
      cat_necessary_desc:
        "Mantengono attiva la sessione e ricordano la lingua scelta. Senza di essi il sito non può funzionare.",
    },
  },
  en: {
    nav: {
      features: "Features",
      dashboard: "Dashboard",
      pricing: "Pricing",
      faq: "FAQ",
      cta: "Book a demo",
    },
    hero: {
      eyebrow: "CRM for estheticians · Edition 2026",
      title_a: "Your salon's",
      title_b: "aura,",
      title_c: "amplified.",
      subtitle:
        "AURA is the intelligent platform that brings calendar, clients, inventory and AI skin analysis into one experience designed for those who craft beauty.",
      cta_primary: "Start free trial",
      cta_secondary: "See the dashboard",
      // Product facts, not claimed results — verifiable by opening the software.
      highlights: [
        "No installation",
        "30-day trial",
        "Data stored in Europe",
      ],
    },
    features: {
      eyebrow: "Everything you need",
      title: "One tool.",
      title_accent: "A thousand acts of care.",
      subtitle:
        "From booking to follow-up, every detail is designed to save you time and elevate the client experience.",
      items: {
        agenda: {
          title: "Smart calendar",
          desc: "Drag & drop scheduling, intelligent slots and automatic WhatsApp reminders.",
        },
        clienti: {
          title: "Client profiles",
          desc: "Treatment history, preferences and personal notes in one elegant view.",
        },
        trattamenti: {
          title: "Treatment catalogue",
          desc: "Packages, subscriptions and custom pricing for every team member.",
        },
        magazzino: {
          title: "Living inventory",
          desc: "Real-time stock, automatic alerts and supplier orders in one click.",
        },
        fidelity: {
          title: "Fidelity & wallet",
          desc: "Points, rewards and digital gift cards to grow your community.",
        },
        skin: {
          title: "AI skin analysis",
          desc: "Visual skin assessment with treatment suggestions powered by AI.",
        },
        mobile: {
          title: "Mobile app",
          desc: "Your beauty business in your pocket. For you and your clients.",
        },
        preventivi: {
          title: "Quotes & POS",
          desc: "Create elegant quotes and handle counter sales effortlessly.",
        },
        bolle: {
          title: "Auto invoice import",
          desc: "Snap a photo of the delivery note: AI reads products, batches and quantities, then updates inventory live.",
          badge: "AI",
          tag1: "Smart OCR",
          tag2: "Zero manual errors",
          tag3: "Suppliers in sync",
        },
        nails: {
          title: "AI nail rendering",
          desc: "Preview the chosen polish colour directly on your client's hands, before the treatment starts.",
          badge: "AI",
        },
        marketing: {
          title: "Marketing & AI",
          desc: "Automated birthday campaigns, client recall and newsletters with copy generated by Artificial Intelligence.",
          badge: "AI",
        },
      },
    },
    dashboard: {
      eyebrow: "Dashboard preview",
      title: "One view. Everything in hand.",
      subtitle:
        "Open AURA and get an instant morning briefing: appointments, expected revenue, clients to call back and low stock. No chaos, just clarity.",
      bullet_1: "Personalised AI briefing every morning",
      bullet_2: "Real-time KPIs with elegant charts",
      bullet_3: "Top performers, goals and monthly trends",
    },
    pricing: {
      eyebrow: "Our plans",
      title: "The right plan",
      title_accent: "for every atelier.",
      subtitle: "Three tiers tailored to your salon's stage. Request a personalised quote with no commitment.",
      most_popular: "Most popular",
      cta: "Request a quote",
      custom_price: "Tailored",
      plans: {
        essence: {
          name: "Essence",
          desc: "For those starting in style.",
          features: [
            "Unlimited smart calendar",
            "Up to 500 client profiles",
            "WhatsApp reminders",
            "Owner mobile app",
            "Email support",
          ],
        },
        atelier: {
          name: "Atelier",
          desc: "The favourite of growing salons.",
          features: [
            "Everything in Essence +",
            "Unlimited client profiles",
            "Inventory & suppliers",
            "Fidelity, gift cards, quotes",
            "Multi-operator (up to 5)",
            "Priority support",
          ],
        },
        maison: {
          name: "Maison",
          desc: "For boutique salons and chains.",
          features: [
            "Everything in Atelier +",
            "Unlimited AI Skin Analysis",
            "Unlimited operators & multi-site",
            "API & custom integrations",
            "Dedicated onboarding",
            "Personal account manager",
          ],
        },
      },
    },
    faq: {
      eyebrow: "Frequently asked",
      title: "Got questions?",
      title_accent: "We know it matters.",
      items: [
        {
          q: "Do I need to install anything?",
          a: "No. AURA is fully cloud-based. Open your browser or mobile app and you're ready. No installation, no updates to manage.",
        },
        {
          q: "Can I import data from my old system?",
          a: "Yes. Our team handles the full migration of client profiles, calendar, treatments and history at no cost. It usually takes 48 hours.",
        },
        {
          q: "Can my clients book online?",
          a: "Absolutely. Every plan includes a custom booking page with your logo and colours, integrated with Instagram and Google.",
        },
        {
          q: "How does AI Skin Analysis work?",
          a: "You take a photo of the client's face — the AI analyses tone, hydration and imperfections, then suggests the most suitable treatments from your catalogue.",
        },
        {
          q: "Can I cancel anytime?",
          a: "Always. No commitment, no penalty. Cancel with one click from your admin panel.",
        },
      ],
    },
    final_cta: {
      eyebrow: "Start today",
      title: "Switch on the aura",
      title_accent: "of your salon.",
      subtitle: "30-day free trial. Free setup. No credit card required.",
      cta_primary: "Book a demo",
      cta_secondary: "Talk to a consultant",
    },
    footer: {
      tagline: "The intelligent CRM for contemporary estheticians.",
      product: "Product",
      company: "Company",
      legal: "Legal",
      links: {
        features: "Features",
        pricing: "Pricing",
        dashboard: "Dashboard",
        contact: "Contact",
        ai: "Use of AI",
        legal_notice: "Legal notice",
        privacy: "Privacy Policy",
        terms: "Terms of service",
        cookies: "Cookie Policy",
        cookie_prefs: "Cookie preferences",
      },
      copyright: "© 2026 AURA. All rights reserved.",
    },
    demo_form: {
      title: "Book a free demo",
      subtitle: "We'll call you back within 24 hours to show you AURA live.",
      name: "Full name",
      name_ph: "Your name",
      email: "Email",
      email_ph: "you@salon.com",
      phone: "Phone",
      phone_ph: "+44 ...",
      salon: "Salon name",
      salon_ph: "e.g. Bellezza Atelier",
      plan: "Plan of interest",
      plan_any: "Not sure yet",
      message: "Tell us about you (optional)",
      message_ph: "How many operators, which software you use today...",
      consent: "I have read and understood the ",
      privacy_link: "privacy notice",
      privacy_note:
        "We use your details only to get back to you and show you AURA. No marketing without your separate consent, no sharing with third parties.",
      submit: "Book the demo",
      submitting: "Sending…",
      success_title: "Thank you ✨",
      success_msg: "We received your request. We'll get in touch shortly.",
      success_close: "Close",
      error: "Something went wrong. Please try again shortly.",
    },
    cookies: {
      title: "Only essential cookies",
      // Testo mostrato quando NON ci sono categorie non necessarie: dice la
      // verità sullo stato attuale del sito, senza promettere scelte che non
      // esistono.
      body_technical:
        "This site only uses technical cookies, needed to make it work and to keep you signed in. No profiling, no analytics, no third-party trackers.",
      body_granular:
        "We use technical cookies, always active. Other cookies are only installed if you agree — you can accept, reject or choose one by one.",
      ack: "Got it",
      accept: "Accept all",
      reject: "Essential only",
      customize: "Customise",
      save: "Save preferences",
      more: "Cookie Policy",
      close_aria: "Close the notice without accepting",
      always_on: "Always on",
      cat_necessary_title: "Technical cookies",
      cat_necessary_desc:
        "Keep your session alive and remember your language. Without them the site cannot work.",
    },
  },
};

export const ASSETS = {
  // Tutte le immagini sono servite dal nostro dominio. Caricarle da CDN di
  // terzi (Unsplash, CDN dello scaffolding) trasmetterebbe l'IP di ogni
  // visitatore a quei fornitori prima di qualsiasi consenso, e legherebbe il
  // sito alla disponibilità di servizi su cui non abbiamo controllo.
  // Le foto d'ambiente provengono da Unsplash e sono usate secondo la
  // Unsplash License; sono immagini illustrative, non ritraggono clienti reali.
  logo: "/assets/brand-logo.jpg",
  dashboard: "/assets/dashboard-preview.png",
  heroBg: "/assets/hero-bg.png",
  spa: "/assets/spa.jpg",
  facial: "/assets/facial.jpg",
  skincare: "/assets/skincare.jpg",
  esthetician: "/assets/esthetician.jpg",
  hands: "/assets/hands.jpg",
  agenda: "/assets/agenda.jpg",
  phone: "/assets/phone.jpg",
  clienti: "/assets/client_records.png",
  trattamenti: "/assets/treatment_catalog.png",
  magazzino: "/assets/live_inventory.png",
  preventivi: "/assets/quotes_sales.png",
  marketing: "/assets/marketing_ai.png",
};
